<template>
  <div class="mt-16 px-6 h-full flex flex-col">
    <h2 class="text-2xl font-bold">{{ t("location_header") }}</h2>
    <p v-if="type == 'book-out' "class="mt-6 text-base">{{ t(`location_book_in`) }}</p>
    <p v-if="type == 'bag' "class="mt-6 text-base">{{ t(`location_bags`) }}</p>
    <p v-else class="mt-6 text-base">{{ t(`location_text_type`, {type: t(type).toLocaleLowerCase()}) }}</p>
    <img class="mx-auto mt-16" src="../assets/graphic.svg" alt="" />
    <div class="max-w-lg mx-auto w-full pt-4 pb-6">
      <p v-if="cordError && !distanceError" class="">{{ t("cord_error") }}</p>
      <p v-if="distanceError" class="">{{ t("distance_error") }}</p>
      <p v-if="boxMissing" class="">{{ t("box_error") }}</p>
      <p v-if="boxNotFound" class="">{{ t("box_not_found") }}</p>
      <p v-if="!boxOnline" class="">{{ t("box_offline") }}</p>
      <Button
        v-if="!cordError && !distanceError && !boxNotFound && boxOnline"
        @click="confirmLocation()"
        :loading="loading"
        class="mt-16 text-center cursor-pointer"
        :text="t('confirm_location')"
      >
      </Button>
      <Button v-if="cordError || distanceError" @click="denyLocation()" :loading="loading" class="mt-16 text-center" :text="t('im_close')"> </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  boxId: string;
  boxNotFound: boolean;
  boxOnline: boolean;
  type: string;
  client: string;
}>();
const config = useRuntimeConfig();
const { t } = useI18n();
const emit = defineEmits(["update:modelValue"]);

const cordError = ref(false);
const distanceError = ref(false);
const boxMissing = ref(false);
const loading = ref(false);

function confirmLocation() {
  loading.value = true;
  if ("permissions" in navigator) {
    navigator.permissions
      .query({
        name: "geolocation",
      })
      .then((permissionStatus) => {
        permissionStatus.onchange = () => {
          if (permissionStatus.state === "granted") {
            getCurrentPosition();
          } else if (permissionStatus.state === "denied") {
            distanceError.value = true;
            loading.value = false;
          }
        };

        if (permissionStatus.state === "denied") {
          distanceError.value = true;
          loading.value = false;
        } else {
          getCurrentPosition();
        }
      })
  } else {
    distanceError.value = true;
    loading.value = false;
  }
}
function denyLocation() {
  emit("update:modelValue", {
    latitude: 0,
    longitude: 0,
  });
}

function getCurrentPosition() {
  navigator.geolocation.getCurrentPosition(checkDistance, (err) => {
    cordError.value = true;
    loading.value = false;
  });
}

function checkDistance(pos: GeolocationPosition) {
  $fetch(`${config.public.apiBase}/molo/unlock/${props.boxId}/distance`, {
    method: "post",
    body: {
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
    },
    onResponse({ request, response, options }) {
      if (response.status == 404) {
        boxMissing.value = true;
        loading.value = false;
        return;
      }
      if (response._data.out_of_bounds) {
        distanceError.value = true;
        loading.value = false;
      } else {
        emit("update:modelValue", {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
        loading.value = true;
      }
    },
    onResponseError({ request, response, options }) {
      loading.value = false;
    },
  });
}
</script>
